import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import { AppProvider } from "./contexts/AppContext";
import { InventoryProvider } from "./contexts/InventoryContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <AppProvider>
          <InventoryProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <AppRoutes />
            </BrowserRouter>
          </InventoryProvider>
        </AppProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
